import { Stream } from '@engoo/realtime-protocol/stream';
import { chatReducer, ChatState } from 'app/models/chat/reducer';
import {
  LWWDocumentManager,
  IActionHandler,
} from 'app/services/rtc/sync/documentmanagers/lww';
import { tFunctionType } from 'app/services/localization';
import { IEncodedChatAction } from '@engoo/realtime-protocol/chat';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';
import { IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';

const INIT_ACTION_TYPE = Symbol('init');

export type ChatManager = LWWDocumentManager<ChatState, IEncodedChatAction>;
type ChatActionHandler = IActionHandler<ChatState, IEncodedChatAction>;

export type ChatDocumentManagerState = IDocumentManagerState<
  ChatState,
  ChatManager
>;

const managerType: IDocumentManagerFactory<
  ChatState,
  IEncodedChatAction,
  ChatActionHandler,
  ChatManager
> = LWWDocumentManager;

const actionHandler: IActionHandler<ChatState, IEncodedChatAction> = {
  apply: chatReducer,
};

export const ChatDocumentSpec = {
  managerType,
  actionHandler,
  initialState: chatReducer(undefined, { type: INIT_ACTION_TYPE }),
  name: (t: tFunctionType) => t('rtc.features.chat.name'),
};

export default {
  [Stream.Chat]: ChatDocumentSpec,
};
